import {DateTime, Notifier} from "@intermesh/goui";
import {PortalConfig} from "../config.js";
import {ServerApi} from "./ServerApi.js";

type lang = { [key: string]: { [key: string]: { [key: string]: string } } };

export class Translate {
	public missing: any = {};
	public langKey: string;
	private lang: lang = {};
	private fallbackLang: lang = {};
	private defaultPkg = "core";
	private defaultModule = "core";

	constructor() {
		this.langKey = "translations_en";
		if (sessionStorage.getItem("language")) {
			this.langKey = "translations_" + sessionStorage.getItem("language")!.toLowerCase();
		}
		if (!localStorage.getItem("translations_en")) {
			const url = ServerApi.url("webclient/language/frontend/en", {});
			ServerApi.call(url).then((response) => {
				if (response.success && response.data) {
					const langData = response.data["en"];
					langData.expiresAt = Date.now() + (24 * 60 * 60 * 1000);
					localStorage.setItem(this.langKey, JSON.stringify(response.data["en"]));
					this.lang = JSON.parse(localStorage.getItem(this.langKey)!);
					this.fallbackLang = JSON.parse(localStorage.getItem(this.langKey)!);
				}
			});
		} else {
			this.lang = JSON.parse(localStorage.getItem(this.langKey)!);
			this.fallbackLang = JSON.parse(localStorage.getItem("translations_en")!);
		}
	}

	public static t(key: string, pkg?: string, module?: string, params?: { [x: string]: string; }): any {
		pkg = pkg || translate.defaultPkg;
		module = module || translate.defaultModule;
		params = params || {};

		let value = key;
		if (pkg in translate.lang && module in translate.lang[pkg] && key in translate.lang[pkg][module]) {
			value = translate.lang[pkg][module][key];
		} else if (pkg in translate.fallbackLang && module in translate.fallbackLang[pkg] && key in translate.fallbackLang[pkg][module]) {
			value = translate.fallbackLang[pkg][module][key];
			// } else if (pkg == "core" && module == "core") {
			// TODO: Do I still need this?
			// TODO? Missing keys?

			//     if (!translate.missing[pkg]) {
			//         translate.missing[pkg] = {};
			//     }
			//
			//     if (!translate.missing[pkg][module]) {
			//         translate.missing[pkg][module] = {};
			//     }
			//
			//     translate.missing[pkg][module][key] = key;
			//
			// if (translate.lang.core.core.key) {
			//     value = translate.lang.core.key;
			// }
		} else if (pkg !== "core" && module !== "core") {
			value = t(key, "core", "core", params);
		}

		for (const paramKey in params) {
			value = value.replace("{" + paramKey + "}", params[paramKey]);
		}
		return value;
	}

	public static overrideTranslation(lang: string, key: string, value: string) {
		lang = lang.toLowerCase();
		translate.lang['core']['core'][key] = value;
		localStorage.setItem("translations_" + lang, JSON.stringify(translate.lang));
	}

	async load() {
		let langCode = sessionStorage.getItem("language") || PortalConfig.language;
		langCode = langCode.toLowerCase();
		this.langKey = "translations_" + langCode;

		if (langCode !== "en" && !localStorage.getItem(this.langKey)) {
			try {
				const url = ServerApi.url("webclient/language/frontend/" + langCode, {});
				const response = await ServerApi.call(url);
				if (response.success && response.data) {
					const langData = response.data[langCode];
					langData.expiresAt = Date.now() + (24 * 60 * 60 * 1000); // 1 day
					localStorage.setItem(this.langKey, JSON.stringify(langData));
					this.lang = JSON.parse(localStorage.getItem(this.langKey)!);
				} else {
					console.warn(response.message);
					langCode = "en";
					this.langKey = "translations_en";
					this.lang = JSON.parse(JSON.parse(localStorage.getItem(this.langKey)!));
				}
			} catch (err) {
				Notifier.error(err, 3000);
				throw (err);
			}
		} else {
			this.lang = JSON.parse(localStorage.getItem(this.langKey)!);
		}
		DateTime.staticInit(langCode)
		return this.lang;
	}

	public static clear(): void {
		if (localStorage.length === 0) {
			return;
		}
		for (let i = 0, l = localStorage.length; i < l; i++) {
			const key = localStorage.key(i);
			if (key && key.startsWith("translations_")) {
				const l = JSON.parse(localStorage.getItem(key) as string);
				if (!l.expiresAt || l.expiresAt < Date.now()) {
					localStorage.removeItem(key);
				}
			}
		}
	}
}


export const translate = new Translate();

export const t = Translate.t;